var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"integration-app"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"integration-app-logo"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t("Warehouse")))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }